import React from 'react';
import PropTypes from 'prop-types';
import { formatDateTime, normalizeUtcTimestamp } from 'helpers/dateTimeFormatter';
import { IconClose } from 'svgIcons/MotionPortalIcons';
import { translate } from 'helpers/translateHelper';
import { setMaxPrecision } from 'helpers/formatters';
import { MAX_PRECISION } from '../constants';
import { SPEED_UNIT } from '../FFT2D/constants';

const EchartTimestampRemove = (props) => {

    const {
        selectedTimestamps,
        setSelectedTimestamps,
        selectedAsset,
        selectedOrganization,
        getFFTDataByTimestamp,
        fftData
    } = props;

    const handleRemoveTimestamp = (timestamp) => {
        const newTimestamps = selectedTimestamps.filter(
            t => t !== timestamp
        );

        setSelectedTimestamps(newTimestamps, selectedAsset, selectedOrganization);
        getFFTDataByTimestamp(newTimestamps);
    };

    const timestampLabel = (timestamp) => {
        const fft = fftData?.find(fft => formatDateTime(normalizeUtcTimestamp(fft.timestamp)) === formatDateTime(normalizeUtcTimestamp(timestamp)));
        if (!fft) {
            return formatDateTime(normalizeUtcTimestamp(timestamp));
        }
        return `${formatDateTime(normalizeUtcTimestamp(fft.timestamp))} — ${translate('ABB.Powertrain.Frontend.fftEchartSpeedXaxisText')}: ${fft?.speed !== null && fft?.speed !== undefined ? setMaxPrecision(Number(fft.speed), MAX_PRECISION) + ' ' + (fft?.speedUnitSymbol || SPEED_UNIT) : '—'}`;
    };

    return (
        <div className='echart-timestamp-remove'>
            {selectedTimestamps.map((timestamp) =>
                <div key={timestamp} className='timestamp-item'>
                    <span
                        className={'timestamp-legend-label'}
                    >
                        {timestampLabel(timestamp)}
                    </span>
                    {selectedTimestamps?.length > 1 &&
                        <button type='button' className='close-icon' onClick={() => handleRemoveTimestamp(timestamp)}>
                            <IconClose />
                        </button>
                    }
                </div>
            )}
        </div>
    );
};

EchartTimestampRemove.propTypes = {
    selectedTimestamps: PropTypes.arrayOf(PropTypes.string).isRequired,
    setSelectedTimestamps: PropTypes.func.isRequired,
    selectedAsset: PropTypes.object,
    selectedOrganization: PropTypes.object,
    getFFTDataByTimestamp: PropTypes.func.isRequired,
    fftData: PropTypes.arrayOf(PropTypes.object).isRequired
};

EchartTimestampRemove.defaultProps = {
    selectedAsset: null,
    selectedOrganization: null
};

export default EchartTimestampRemove;
